exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.right-bar[data-v-1f854836]{\n    overflow-y: auto;\n}\n", ""]);

// exports
